import * as React from 'react';

function SvgLegalities(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <g fill="#fff">
        <path
          data-name="Path 4509"
          d="M2.593 22.251h10.759a.593.593 0 00.593-.593v-1.266a1.783 1.783 0 00-1.187-1.678v-.771a1.705 1.705 0 00-1.7-1.7H4.89a1.705 1.705 0 00-1.7 1.7v.772A1.783 1.783 0 002 20.392v1.266a.593.593 0 00.593.593zm2.3-4.826h6.162a.517.517 0 01.517.517v.67h-7.2v-.67a.517.517 0 01.518-.516zm-1.7 2.967a.594.594 0 01.593-.593h8.386a.594.594 0 01.593.593v.672H3.187zm0 0"
        />
        <path
          data-name="Path 4510"
          d="M8.834 14.352a1.779 1.779 0 003.189-1.281 7 7 0 001.472-.42l5.555 7.378a1.78 1.78 0 102.844-2.141l-5.555-7.379a7.01 7.01 0 00.811-1.3 1.78 1.78 0 002.112-2.71l-2.855-3.79a1.779 1.779 0 00-3.189 1.281 6.986 6.986 0 00-5.126 3.859 1.78 1.78 0 00-2.113 2.711zm6.68-2.965l.792 1.052-.948.714-.792-1.052a6.986 6.986 0 00.948-.714zm5.314 8.045a.594.594 0 01-.831-.117l-3.924-5.216.948-.714 3.925 5.214a.594.594 0 01-.118.833zm-6.2-16.127a.594.594 0 01.831.117l2.855 3.792a.593.593 0 01-.948.714l-2.855-3.792a.594.594 0 01.117-.831zm-.868 1.806l2.461 3.269a5.812 5.812 0 01-4.74 3.569L9.02 8.68a5.806 5.806 0 014.74-3.569zm-6.716 3.9a.593.593 0 01.831.117l2.855 3.792a.593.593 0 01-.948.714L6.927 9.846a.593.593 0 01.117-.831zm0 0"
        />
      </g>
    </svg>
  );
}

export default SvgLegalities;
